/* Footer newsletter: submit without reloading the page.

   {% form 'customer' %} is a plain POST, so subscribing used to reload the
   whole site just to render one line of confirmation. This posts the same
   form with fetch and asks the SERVER for the verdict — the response is the
   fully rendered page, so we look for the success or error element Liquid put
   in it rather than guessing from the status code. Same markup, same CSS
   animation, no reload.

   Progressive enhancement: without JS, or if the request fails, the form
   falls back to its native submit and the Liquid branch renders as before. */
(function () {
  'use strict';

  var HOLD_MS = 4600; /* the CSS fade ends at 4s + 420ms; clear up after it */

  function init() {
    var form = document.querySelector('.fm-footer__form');
    if (!form || !window.fetch || !window.DOMParser) return;

    var field = form.querySelector('.fm-footer__field');
    var input = form.querySelector('.fm-footer__input');
    var timer = null;

    function clearMessages() {
      var old = form.querySelectorAll('.fm-footer__ok, .fm-footer__error');
      Array.prototype.forEach.call(old, function (el) { el.remove(); });
      if (timer) { clearTimeout(timer); timer = null; }
    }

    function showSuccess(text) {
      clearMessages();
      var p = document.createElement('p');
      p.className = 'fm-footer__ok';
      p.setAttribute('role', 'status');
      p.innerHTML =
        '<svg class="fm-footer__tick" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<path d="M4 12.5 L10 18.5 L20 6.5" /></svg><span></span>';
      p.querySelector('span').textContent = text;
      form.appendChild(p);
      input.value = '';
      /* Remove once the fade has finished so a second signup animates fresh. */
      timer = setTimeout(function () { p.remove(); timer = null; }, HOLD_MS);
    }

    function showError(text) {
      clearMessages();
      var s = document.createElement('small');
      s.className = 'fm-footer__error';
      s.setAttribute('role', 'status');
      s.textContent = text;
      field.insertAdjacentElement('afterend', s);
    }

    form.addEventListener('submit', function (e) {
      if (!input.value || !input.checkValidity()) return; /* let the browser handle it */
      e.preventDefault();

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' }
      })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var ok = doc.querySelector('.fm-footer__ok');
          var err = doc.querySelector('.fm-footer__error');
          if (ok) {
            showSuccess(ok.textContent.trim());
          } else if (err) {
            showError(err.textContent.trim());
          } else {
            /* Server said something we don't recognise — hand it the form. */
            form.submit();
          }
        })
        .catch(function () { form.submit(); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
